import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { LeadHistoryComponent } from "./lead-history.component";

import { MatListModule } from "@angular/material/list";
import { MatTableModule } from "@angular/material/table";
import { IconModule } from "@visurel/iconify-angular";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";

@NgModule({
    declarations: [LeadHistoryComponent],
    imports: [
        CommonModule,
        MatListModule,
        MatTableModule,
        IconModule,
        MatIconModule,
        MatButtonModule,
    ],
    exports: [LeadHistoryComponent],
})
export class LeadHistoryModule {}
